import hk from "hotkeys-js";

$(() => {

    const mainSearch = $('form.global-search textarea');

    mainSearch.select2({
        minimumInputLength: 2,
        dropdownAutoWidth: true,
        language: {
            inputTooShort: function () {
                return mainSearch.data('hint');
            }
        },
        templateResult: (item: any) => {
            if (!item.id) {
                return item.text;
            }
            return $(`<div class="search-result">
               <!-- <img src="${item.photo}" alt="${item.text}" /> -->
                <div class="search-result-text">
                    ${item.text} 
                 <!--   <div class="search-result-preview">${item.preview}</div> -->
                </div>
            </div> `);
        },
        placeholder: mainSearch.attr('placeholder') + (/(Mac|iPhone|iPod|iPad)/i.test(navigator.platform) ? ' [cmd+space]' : ' [ctl+space]'),
        matcher: (params, data) => {
            // Always return the object if there is nothing to compare
            if ($.trim(params.term) === '') {
                return data;
            }

            // Do a recursive check for options with children
            if (data.children && data.children.length > 0) {
                // Clone the data object if there are children
                // This is required as we modify the object to remove any non-matches
                const match = $.extend(true, {}, data);

                // Check each child of the option
                for (let c = data.children.length - 1; c >= 0; c--) {
                    const child = data.children[c];

                    // @ts-ignore
                    const matches = this.select2AjaxMatcher(params, child);

                    // If there wasn't a match, remove the object in the array
                    if (matches == null) {
                        match.children.splice(c, 1);
                    }
                }

                // If any children matched, return the new object
                if (match.children.length > 0) {
                    return match;
                }

                // If there were no matching children, check just the plain object
                // @ts-ignore
                return this.select2AjaxMatcher(params, match);
            }

            const original = data.text.toUpperCase();
            const term = params.term.toUpperCase();

            // Check if the text contains the term
            if (original.indexOf(term) > -1) {
                return data;
            }

            // If it doesn't contain the term, don't return anything
            return null;
        },
        sorter: function (data) {
            return data;
        },
        ajax: {
            url: mainSearch.data('url'),
            dataType: 'json',
            processResults: (data) => {
                return {
                    results: data.items
                };
            }
        },
    }).on('select2:select', e => document.location.replace(e.params.data.id));

    const openSelectBox = () => mainSearch.select2("open") && false;

    mainSearch.parents('form').on('click', openSelectBox);
    hk('ctrl+space, command+space', openSelectBox);
});
